import { render, staticRenderFns } from "./BrandSection.vue?vue&type=template&id=788ad0f8&scoped=true&"
import script from "./BrandSection.vue?vue&type=script&lang=js&"
export * from "./BrandSection.vue?vue&type=script&lang=js&"
import style0 from "./BrandSection.vue?vue&type=style&index=0&id=788ad0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ad0f8",
  null
  
)

export default component.exports